import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { LanguageProvider } from './context/LanguageContext'
import { GeneralProvider } from './context/GeneralContext'
import { ThemeProvider } from './context/ThemeProvider'
import { AuthProvider } from './context/AuthContext'
import * as serviceWorker from './serviceWorker'
import Layout from './components/Layout'
import { Close as CloseIcon } from '@material-ui/icons'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './Services/keycloak'
import { handleNotificationAlert } from './utils/helpers'

const CloseButton = ({ closeToast, className }) => (
  <CloseIcon className={className} onClick={closeToast}/>
)


ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: 'check-sso',
      checkLoginIframe: false,
      promiseType: 'native',
      pkceMethod: 'S256',
    }}
    onEvent={(event, error) => {
      // console.log('event', event)
      // console.log('error', error)
      if (!!error?.error) {
        handleNotificationAlert({
          type: 'defence',
          message: <><strong>Keycloak {event}</strong>: {error?.error}</>,
          color: 'error'
        }, 'error')
      }
    }}
    onTokens={(tokens) => {
      // console.log('onKeycloakTokens', tokens)
    }}
  >
    <Router forceRefresh={true}>
      <LanguageProvider>
        <AuthProvider>
          <GeneralProvider>
            <ThemeProvider>
              <ToastContainer
                className={'toasts-container'}
                closeButton={
                  <CloseButton className={'notification-close-button'}/>
                }
                limit={5}
                closeOnClick={false}
                progressClassName={'notification-progress'}
              />
              <Layout/>
            </ThemeProvider>
          </GeneralProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  </ReactKeycloakProvider>,
  document.getElementById('root')
)

serviceWorker.unregister()
